import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=221f50b0&scoped=true"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"
import style0 from "./Changes.vue?vue&type=style&index=0&id=221f50b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f50b0",
  null
  
)

export default component.exports